import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import { PolicyCard } from '@/components/molecule/PolicyCard';
import { EmptyScrapList } from './EmptyScrapList';
export const PolicyScrapList = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/member/wishlist/policy"](),
      select: _temp,
      placeholderData: keepPreviousData
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: policyScrap
  } = useQuery(t0);
  if (!policyScrap?.totalCount) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyScrapList />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== policyScrap.totalCount) {
    t1 = <p className="px-20 py-10 font-500 text-Gray-black typo-body4">총 {policyScrap.totalCount}개</p>;
    $[2] = policyScrap.totalCount;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== policyScrap.contents) {
    t2 = policyScrap?.contents?.map(_temp2);
    $[4] = policyScrap.contents;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <ul className="flex flex-col">{t2}</ul>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <article className="flex flex-col">{t1}{t3}</article>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context;
}
function _temp2(policy) {
  return <li key={policy.id} className="border-b border-Gray-200 last:border-none"><PolicyCard variant="scrap" benefit={policy.supportBenefit} bookmarkCount={policy.wishlistCount} commentCount={policy.commentCount} endAt={policy.expirationDate} id={policy.id} idIdx={policy.metaPolicyIdIdx} imageUrl={policy.agencyLogo} isBookmarked={policy.wishlistYN} name={policy.policyName} agency={policy.agency} /></li>;
}